// extracted by mini-css-extract-plugin
module.exports = {"input":"Button_input__ZkZZ-","loading":"Button_loading__sLXLq","disabled":"Button_disabled__3dWAy"};